import { NextPageContext } from 'next';
import getConfig from 'next/config';
import { _reAuthenticate } from 'src/actions/authActions';
const { API_BASE_URL } = getConfig().publicRuntimeConfig;

export const fetchInitialData = async (
  accessToken: string,
  path: string,
  ctx: NextPageContext,
  id?: string,
) => {
  const url = id ? `${API_BASE_URL}${path}/${id}` : `${API_BASE_URL}${path}`;
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  switch (res.status) {
    case 200:
      return await res.json();
    case 401:
      const result = await _reAuthenticate(ctx);

      if (!result?.newAccessToken) return null;

      const refreshedRes = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${result.newAccessToken}`,
        },
      });

      if (refreshedRes.status === 200) return await refreshedRes.json();

      return null;
    default:
      return null;
  }
};

export const sendDataAPI = async (
  accessToken: string,
  path: string,
  ctx: NextPageContext,
  data: any,
  method: 'POST' | 'PUT',
) => {
  const url = `${API_BASE_URL}${path}`;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  }

  if(ctx?.req?.headers) {
    headers['User-Agent'] = ctx.req.headers['user-agent']
  }

  const res = await fetch(url, {
    method: method,
    headers,
    body: JSON.stringify(data),
  });
  // LIC-4195
  //console.log(`# sendDataAPI status ${res.status}, path ${path}`);
  switch (res.status) {
    case 200:
    case 201:
      return await res.json();
    case 401:
      const result = await _reAuthenticate(ctx);
      // LIC-4195
      // console.log("# _reAuthenticate");
      // console.log(JSON.stringify(result));
      // console.log("______________");
      if (!result?.newAccessToken) return null;

      const refreshedRes = await fetch(url, {
        method: method,
        headers: {
          Authorization: `Bearer ${result?.newAccessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (refreshedRes.status === 200) return await refreshedRes.json();

      return null;
    default:
      const jsonError = await res.json();
      // LIC-4195
      console.log("# Unknow Error");
      //console.log(jsonError?.code);
      if (jsonError?.code) {
        return jsonError;
      }
      return null;
  }
};

export const fetchInitialDataPublic = async (path: string, id?: string) => {
  const url = id ? `${API_BASE_URL}${path}/${id}` : `${API_BASE_URL}${path}`;
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (res.status === 200) {
    return await res.json();
  }

  return null;
};
